// TODO: rename purchase confirmation vars to great choice
import React from 'react';
import { browserHistory } from 'react-router';

import Button from '../Button';
import SiteNav from '../SiteNav';

import { useScrollToTop } from '@evdy/web-core/dist/customHooks';

import styles from './GreatChoice.module.scss';

const {
  'purchase-confirmation': purchaseConfirmationClass,
  'purchase-confirmation-body': purchaseConfirmationBodyClass,
  'protect-icon': protectIconClass,
  'header-copy': headerClass,
  'body-copy': bodyClass,
  'body-section-one': bodySectionOne,
  'body-section-two': bodySectionTwo,
  'help-section': helpSectionClass
} = styles;

const GreatChoice = () => {
  // scroll to top on mount
  useScrollToTop();

  const handleNextClick = () => {
    browserHistory.push('/b/preparing-package');
  };

  return (
    <div className={purchaseConfirmationClass}>
      <SiteNav />
      <div className={purchaseConfirmationBodyClass}>
        <h4 className={headerClass}>Great choice!</h4>
        <h4 className={bodyClass}>We just need a few more details to complete your purchase.</h4>
        <p className={bodySectionOne}>
          Your funds will be protected with a life insurance policy issued by Homesteaders Life
          Company so your money is available for your family when they need it.
        </p>
        <p className={bodySectionTwo}>
          Next, we’ll confirm your identity and personal details to ensure your privacy and secure
          your package purchase.
        </p>
        <Button clickAction={handleNextClick} copy="Confirm my information" width="full" />
      </div>
    </div>
  );
};

export default GreatChoice;
